<template>
  <v-app>
    <v-app-bar class="integrity" height="58" app clipped-left flat>
      <template v-if="backButtonConfig.displayButton">
        <template>
          <v-btn :text="backButtonConfig.displayText" :icon="!backButtonConfig.displayText" class="white--text" @click="goBack()">
            <v-icon :left="backButtonConfig.displayText">{{ backButtonConfig.buttonIcon }}</v-icon>
            <span v-if="backButtonConfig.displayText">{{ backButtonConfig.buttonText }}</span>
          </v-btn>
        </template>

        <v-spacer />

        <template v-if="!backButtonConfig.displayText">
          <template v-if="(policyTitle || null) === null || policyTitle.trim() === ''">
            <div v-if="client" class="white--text text-center" style="overflow: ellipsis;white-space:nowrap;text-overflow:ellipsis;">
              {{ name }}
            </div>
          </template>
          <template v-else>
            <div>
              <div v-if="client" class="white--text text-center" style="overflow: ellipsis;white-space:nowrap;text-overflow:ellipsis;">
                {{ name }}
              </div>
              <div v-if="policyTitle" class="caption white--text text-center">
                <span>{{ policyTitle }}</span>
                <span v-if="(lobName || null) !== null && lobName.trim() !== ''"> ({{ lobName }})</span>
              </div>
            </div>
          </template>
        </template>

      </template>
      <template v-else>
        <router-link tag="span" to="/" class="noselect">
          <v-toolbar-title class="headline text-uppercase white--text">
            <div>
              <span>HawkSoft</span>
              &nbsp;
              <span class="font-weight-thin">Agent</span>
            </div>
          </v-toolbar-title>
        </router-link>
      </template>

      <v-spacer />

      <v-app-bar-nav-icon v-if="userIsSignedIn" class="white--text" @click="drawer = !drawer" />
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <NavMenu v-model="drawer" />
    <v-snackbar v-if="hasError"
                  v-model="hasError"
                  :timeout="timeout"
                  color="red"
                  class="pb-10">
        {{ error }}
        <v-btn text icon @click="handleReset()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-footer v-if="isInOboSession" padless app>
        <v-card flat tile width="100%" class="red lighten-1 text-center">
          <v-card-text class="white--text">
            <strong>Acting on behalf of {{ hsUserName }} (Agency {{ agencyId }}) </strong>
          </v-card-text>
        </v-card>
      </v-footer>
  </v-app>
</template>

<style lang="scss">
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}

.no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-application {
  font-family: 'Open Sans';
}

.label {
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: rgb(0, 76, 151);
  }
  .value {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: rgb(118, 118, 118);
  }
</style>

<script>
import backButtonService from '@/services/shared/backButtonService.js';

import NavMenu from '@/components/NavMenu.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    NavMenu
  },
  data () {
    return {
      drawer: false,
      environmentsError: null,
      timeout: 0,
      timeoutId: null
    };
  },
  computed: {
    ...mapState(['error', 'activeClientTab', 'client', 'policyTitle', 'lobName']),
    // ...mapGetters(['getOboAgencyId', 'getOboUserName']),
    ...mapGetters('auth', [
      'isUserSignedIn',
      'userProfile'
    ]),
    environment () {
      return localStorage.getItem('environment');
    },
    environments () {
      return JSON.parse(localStorage.getItem('environments'));
    },
    hasError () {
      return (this.error || null) !== null;
    },
    backButtonConfig () {
      return backButtonService.getBackButtonConfig(this.$route);
    },
    isInOboSession () {
      return false; // tmp
      // return this.getOboUserName().length > 0;
    },
    hsUserName () {
      return this.userProfile.initials;
    },
    agencyId () {
      return this.userProfile.agencyId;
    },
    name () {
      if (this.client.isBusiness) {
        if (this.client.businessName) return this.client.businessName;
        else if (this.client.dba) return this.client.dba;
      }
      return this.client.mainContactName;
    },
    userIsSignedIn () {
      return this.isUserSignedIn;
    }
  },
  watch: {
    hasError: async function () {
      if (this.hasError) {
        this.timeoutId = setTimeout(this.clearError, 15000);
      }
    }
  },
  methods: {
    ...mapActions(['clearError']),
    handleReset () {
      clearTimeout(this.timeoutId);
      this.clearError();
    },
    goBack () {
      backButtonService.handleButtonPress(this.$route, this.$router, this.$gtag);
    }
  }
};
</script>
